/**
 * Drag payloads of the catalog. A board tile and a database card (`board-tile` / `database-tile`,
 * set by their own components) and a section row (`section-row`) are told apart by `type` only, so
 * the section tree can accept resources without knowing their components.
 */
export interface DraggedResource {
  kind: 'board' | 'database';
  id: string;
  workspaceId: string;
}

export const databaseTileData = (workspaceId: string, databaseId: string) => ({
  type: 'database-tile',
  workspaceId,
  databaseId,
});

export const sectionRowData = (workspaceId: string, sectionId: string) => ({
  type: 'section-row',
  workspaceId,
  sectionId,
});

type Data = Record<string | symbol, unknown>;

export function resourceOf(data: Data): DraggedResource | null {
  if (typeof data.workspaceId !== 'string') return null;
  if (data.type === 'board-tile' && typeof data.boardId === 'string') {
    return { kind: 'board', id: data.boardId, workspaceId: data.workspaceId };
  }
  if (data.type === 'database-tile' && typeof data.databaseId === 'string') {
    return { kind: 'database', id: data.databaseId, workspaceId: data.workspaceId };
  }
  return null;
}

export function sectionOf(data: Data): { id: string; workspaceId: string } | null {
  return data.type === 'section-row' &&
    typeof data.sectionId === 'string' &&
    typeof data.workspaceId === 'string'
    ? { id: data.sectionId, workspaceId: data.workspaceId }
    : null;
}
